import { useQuery } from "react-query";
import { customerBusinessService } from "../services";
import {AUTH_USER, GUEST_USER} from "../constants";

const getProfile = async (userId: string | number) => {
  if (!userId) return;
  const response = await customerBusinessService.getCustomerProfile(userId, {
    details: '[addresses,locations,vehicles]'
  })
  return response.data.data;
};

export default function useProfile(
  userId: string | number,
  userType: string = AUTH_USER,
  enabled = true
) {
  return useQuery(["profile", userId], () => getProfile(userId), {
    retry: false,
    staleTime: 0,
    // Guests have no profile — never fetch it for them (covers checkout callers
    // that pass authInfo.type). Loyalty/registered users (AUTH_USER) are unaffected.
    enabled: !!userId && enabled && userType !== GUEST_USER,
    cacheTime: 0,
  });
}
